//#region module
import { AppBar, Box, Grid, Menu, MenuItem, Paper, Tab, Tabs, TextField } from "@mui/material";
import { makeStyles } from '@mui/styles';
import React from "react";
import { ReactComponent as MoreIcon } from "../../../assets/icons/icon-more.svg";
import { useDashboardContext } from "../../../layouts/dashboardView/DashboardView";
import { debounce } from "lodash";


// sheetsAvailable={dashboardState.sheets}
// addNewSheet={addNewSheet}
// handleChangeSheet={handleChangeSheet}
// selectedSheetIndex={selectedSheetIndex}
// handleSheetName={handleSheetName}
// handleDeleteSheet={handleDeleteSheet}
// handleDuplicateSheet={handleDuplicateSheet}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    appBar: {
        color: "inherit",
        backgroundColor: theme.palette.background.paper,
        boxShadow: "none",
    },
    noBorder: {
        border: "none",
    },
    addSheetBtn: {
        [theme.breakpoints.down('md')]: {
            minWidth: '50px',
            padding: '5px 10px'
        },
        [theme.breakpoints.down('md')]: {
            minWidth: '28px',
            padding: '5px'
        },
    },
    menuDropdownItem: {
        fontSize: '14px',
        color: '#202124',
        '&:hover': {
            backgroundColor: '#f6f6f6'
        }
    }
}))
export default function DashboardSheets() {
    const classes = useStyles()
    const [sheetMoreEl, setSheetMoreEl] = React.useState(null);
    const open = Boolean(sheetMoreEl);

    const { dashboardState, changeSheet, updateSheet, deleteSheet, duplicateSheet, currentSheet } = useDashboardContext();

    if (dashboardState.loading) return null;

    const handleSheetMoreClick = (event) => {
        setSheetMoreEl(event.currentTarget);
    };

    const handleSheetMoreClose = () => {
        setSheetMoreEl(null);
    };

    const deleteCurrentSheet = () => {
        deleteSheet({ sheetIndex: dashboardState.currentSheetIndex });
        handleSheetMoreClose();
    }

    const duplicateCurrentSheet = () => {
        const sheet = structuredClone(currentSheet);
        delete sheet._id
        duplicateSheet({ sheetIndex: dashboardState.currentSheetIndex, sheet: sheet })
        handleSheetMoreClose();
    }

    const handleSheetNameChange = debounce((e, i) => {
        const sheet = structuredClone(dashboardState.sheets[i]);
        sheet.sheetName = e.target.value;
        updateSheet({ sheetIndex: i, sheet: sheet })
    }, 400)
    return (
        <AppBar position="static" className={classes.appBar}>
            <Paper square className="dashboard-sheet-tabs">
                <Grid container alignItems="center" justify="center" >
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12} >

                        <Tabs
                            value={dashboardState.currentSheetIndex}
                            onChange={(_, tabValue) => changeSheet(tabValue)}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                        >
                            {
                                dashboardState.sheets?.map((tab, i) => {
                                    return (
                                        <Tab
                                            key={`tabIndex-${tab?.id ?? i}`}
                                            className={"sheet-item "}
                                            value={tab?.id}
                                            label={
                                                <Grid container alignItems="center" justify="center" className="sheet-tab-item" >
                                                    <Box sx={{ width: '95%' }}>
                                                        <TextField
                                                            className="sheet-input"
                                                            variant="standard"
                                                            defaultValue={tab.sheetName}
                                                            size="small"
                                                            onChange={(e) => handleSheetNameChange(e, i)}
                                                        />
                                                    </Box>
                                                    <Box className="sheet-item-more">
                                                        <MoreIcon onClick={handleSheetMoreClick} />
                                                        <Menu
                                                            id="sheet-menu"
                                                            anchorEl={sheetMoreEl}
                                                            open={open}
                                                            onClose={handleSheetMoreClose}
                                                        >
                                                            <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => duplicateCurrentSheet()} >Duplicate</MenuItem>
                                                            <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={deleteCurrentSheet}>Delete</MenuItem>
                                                        </Menu>
                                                    </Box>

                                                </Grid>
                                            }
                                        />
                                    )
                                })
                            }
                        </Tabs>
                    </Grid>
                </Grid>
            </Paper >
        </AppBar >
    );
}
